import type { ButtonProps, UnstyledButtonProps } from '@mantine/core';
import {
  Button as DefaultButtonMantine,
  UnstyledButton as UnstyledButtonMantine,
} from '@mantine/core';

import { applyUiId } from '../Utils/applyComponentGeneratedId';
import classes from './Button.module.css';

const ButtonDefaults = DefaultButtonMantine.extend({
  defaultProps: { size: 'lg', color: 'cobalt' }, // primary settings
  classNames: {
    root: classes.root,
    loader: classes.loader,
    inner: classes.inner,
    section: classes.section,
    label: classes.label,
  },
});

const Button: typeof DefaultButtonMantine = applyUiId(DefaultButtonMantine, 'button');
// Backfill the ButtonMantine export component for backwards compatibility
const ButtonMantine: typeof DefaultButtonMantine = Button;
const UnstyledButton: typeof UnstyledButtonMantine = applyUiId(
  UnstyledButtonMantine,
  'unstyled-button'
);

export { Button, ButtonDefaults, ButtonMantine, UnstyledButton };
export type { ButtonProps, UnstyledButtonProps };
